module.exports = __webpack_public_path__ + "img/facilityInfo_1_3.4033e216.jpg";